
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductsGrid extends Serenity.EntityGrid<CartProductsRow, any> {
        protected getColumnsKey() { return CartProductsColumns.columnsKey; }
        protected getDialogType() { return CartProductsDialog; }
        protected getIdProperty() { return CartProductsRow.idProperty; }
        protected getInsertPermission() { return CartProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return CartProductsRow.localTextPrefix; }
        protected getService() { return CartProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}